var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { characterCountStaticStyle } from './styles';
// Mapping between Text Area size and counter size
var sizeMap = {
    large: 'medium',
    medium: 'small',
    small: 'small',
};
function CharacterCount(_a) {
    var _b;
    var counterAriaLabel = _a.counterAriaLabel, id = _a.id, limit = _a.limit, size = _a.size, value = _a.value;
    var currentCount = (_b = value === null || value === void 0 ? void 0 : value.toString().length) !== null && _b !== void 0 ? _b : 0;
    return (_jsx(Text, __assign({ "aria-label": counterAriaLabel != null
            ? counterAriaLabel({ currentCount: currentCount, limit: limit })
            : "".concat(currentCount, " of ").concat(limit, " characters used"), "aria-live": "polite", as: "p", css: characterCountStaticStyle, id: id, role: "status", size: sizeMap[size] }, { children: _jsx("span", __assign({ "aria-hidden": true }, { children: "".concat(currentCount, " / ").concat(limit) })) })));
}
export default CharacterCount;
